import { getConfig } from '@gokrew/ui/runtime-config';
import { useUtmCapture } from '@gokrew/ui';
import { AppRoutes } from './routes';
import * as Sentry from '@sentry/react';

function App() {
  const { ENABLE_SENTRY, ENVIRONMENT } = getConfig();
  if (ENABLE_SENTRY) {
    Sentry.init({
      dsn: 'https://826fc8bad79528ebe5ef89e59b04e40f@o4510754348859392.ingest.us.sentry.io/4510758834995200',
      environment: ENVIRONMENT,
      sendDefaultPii: true,
    });
  }
  useUtmCapture();
  return <AppRoutes />;
}

export default App;
